/** @returns a promise which resolves when the JS engine is idle, or after a tick of the event
 * loop if that's the best we can do */
export const untilIdle = () =>
  new Promise<void>(resolve => {
    if (typeof requestIdleCallback === 'function') {
      /**
       * Typescript has added a type for requestIdleCallback
       * that appears to be incompatible with how it was used here.
       */
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      requestIdleCallback(resolve);
    } else {
      setTimeout(resolve, 0);
    }
  });
